module.exports = __webpack_public_path__ + "img/due-30-days.a2ac2b64.svg";